// extracted by mini-css-extract-plugin
export default {"constructionBgIcon":"home-page-module--construction-bg-icon--1CTcg"};